import * as React from "react";
export const EventName = (props) => {
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__event-name`, "data-uat": `div-ev-list-${props.componentPrefix}-event-name` }, props.event.eventName));
};
//# sourceMappingURL=EventName.js.map